/**
 * Tough-Bar Builder - Vehicle Module (Step 1)
 * Vehicle selection action methods
 */
window.ToughBarBuilder = window.ToughBarBuilder || {};

window.ToughBarBuilder.vehicle = {
  selectYear(year) {
    this.context = { year };
  },

  selectMake(make) {
    this.context.make = make;
    delete this.context.model;
    delete this.context.trim_level;
  },

  selectModel(model) {
    this.context.model = model;
    delete this.context.trim_level;
  },

  selectTrimLevel(trimLevel) {
    this.context.trim_level = trimLevel;
  },
};
